webpackJsonp([16],{

/***/ 1267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_mixins__ = __webpack_require__(56);



var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/channels/' + this.channelId);

					case 2:
						response = _context.sent;

						this.model = response.data.data;

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

var saveChannel = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var method, url, message;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						method = this.channelId ? 'put' : 'post';
						url = this.channelId ? 'channels/' + this.channelId : 'channels';
						message = this.channelId ? 'actualizó' : 'creó';

						this.model.flagActive = this.model.flagActive ? this.model.flagActive : 1;
						delete this.model.companies;
						delete this.model.id;
						_context2.next = 8;
						return this.$http[method]('//pms.controlinn.com/api' + '/' + url, this.model);

					case 8:
						this.showNotification('La OTA se ' + message + ' de manera correcta.', 'success');
						this.$router.push({ name: 'channels-list' });

					case 10:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function saveChannel() {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	if (this.channelId) {
		this.loadData();
	}
}

function data() {
	return {
		model: {
			codeChannel: '',
			name: ''
		}
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'channels-new',
	created: created,
	data: data,
	methods: {
		loadData: loadData,
		saveChannel: saveChannel
	},
	mixins: __WEBPACK_IMPORTED_MODULE_2__shared_mixins__["a" /* default */],
	props: ['channelId']
});

/***/ }),

/***/ 1433:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".divider-form[data-v-9377637c]{margin:0 -20px;width:100vw}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/channels/New.vue"],"names":[],"mappings":"AACA,+BACE,eAAgB,AAChB,WAAa,CACd","file":"New.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.divider-form[data-v-9377637c] {\n  margin: 0 -20px;\n  width: 100vw;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1518:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1433);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("01dbc856", content, true);

/***/ }),

/***/ 1685:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "title-form"
  }, [_vm._v("Datos de extranet")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.model.name = $$v
      },
      expression: "model.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Código")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.model.codeChannel),
      callback: function($$v) {
        _vm.model.codeChannel = $$v
      },
      expression: "model.codeChannel"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-left": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save btn-save-form mt-3",
    attrs: {
      "type": "button",
      "disabled": !_vm.model.name || !_vm.model.codeChannel
    },
    on: {
      "click": _vm.saveChannel
    }
  }, [_vm._v("\n\t\t\t\t\t\tAceptar\n\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1518)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1267),
  /* template */
  __webpack_require__(1685),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9377637c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/16.f09f079555e92253451d.js